import { render, staticRenderFns } from "./downloadClient.vue?vue&type=template&id=7f5b7fe1&scoped=true&lang=pug"
import script from "./downloadClient.vue?vue&type=script&lang=js"
export * from "./downloadClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5b7fe1",
  null
  
)

/* custom blocks */
import block0 from "./downloadClient.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports